!<template>
<div>
    <div class="modal fade" role="dialog" id="ModalDelete">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Desea Eliminar este elemento?</h4>
                </div>
                
                <div class="modal-footer">
                    <button class="btn-danger btn" @click="accion">Eliminar</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        show() {
            console.log("ENTRE");
            $('#ModalDelete').modal('show')
        },
        hide() {
            $('#ModalDelete').modal('hide')
        },
        accion() {
            this.$emit('eliminar')
            this.hide()
        }
    },
    watch: {}
}
</script>
